// extracted by mini-css-extract-plugin
export default {"icon-button-wrapper":"_11YO4","iconButtonWrapper":"_11YO4","number":"_2zVJh"};